module.exports = new __parcel__URL__("cornershop-landing.8b40f87a.png").toString();